import { render, staticRenderFns } from "./Motifs.vue?vue&type=template&id=6a7e92bc&"
import script from "./Motifs.vue?vue&type=script&lang=js&"
export * from "./Motifs.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports